import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../utils/AuthContext";
import "./Sidebar.css";

const Sidebar = ({ isOpen }) => {
  const { sidebarMenuItems, hasMenuAccess } = useAuth();

  // Menu configuration mapping
  const menuConfig = [
    {
      id: "manage-properties",
      route: "/properties",
      label: "Manage Properties"
    },
    {
      id: "reorder-landing-page",
      route: "/reorder-landing-page",
      label: "Re-order Landing Page"
    },
    {
      id: "add-property",
      route: "/add-property",
      label: "Add Property"
    },
    {
      id: "manage-users",
      route: "/users",
      label: "Manage Users"
    },
    {
      id: "add-user",
      route: "/add-user",
      label: "Add User"
    },
    {
      id: "manage-sellers",
      route: "/sellers",
      label: "Manage Seller"
    },
    {
      id: "add-seller",
      route: "/add-seller",
      label: "Add Seller"
    },
    {
      id: "manage-agencies",
      route: "/agents",
      label: "Manage Agencies"
    },
    {
      id: "add-agency",
      route: "/add-agent",
      label: "Add Agency"
    },
    {
      id: "activity-log",
      route: "/activity-log",
      label: "Activity Log"
    },
    {
      id: "manage-portfolios",
      route: "/portfolios",
      label: "Manage Portfolio"
    },
    {
      id: "add-portfolio",
      route: "/add-portfolio",
      label: "Add Portfolio"
    },
    {
      id: "manage-email-templates",
      route: "/email-templates",
      label: "Email templates"
    }
  ];

  // Filter menu items based on user permissions
  const allowedMenuItems = menuConfig.filter(menuItem => 
    hasMenuAccess(menuItem.id)
  );

  return (
    <div className={`sidebar ${isOpen ? "sidebar-open" : "sidebar-closed"}`}>
      <div className="sidebar-header">
        <img
          src="/CBRE-Excellerate_Logo.6eb65411.svg"
          alt="CBRE Exellerate"
          className="sidebar-logo"
        />
      </div>

      <nav className="sidebar-nav">
        <ul>
          {allowedMenuItems.map(menuItem => (
            <li key={menuItem.id}>
              <Link to={menuItem.route}>{menuItem.label}</Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
